import { createSelector, Selector } from 'reselect';

import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';

import { AppState } from '../state/AppState';
import { MapStateToProps } from '../utils/ConnectUtils';
import { queryStringSelector } from './QueryStringSelectors';
import { selectSessionSite } from './SessionInfoSelectors';

export interface SiteUrlsProps {
  urls: SpacesSiteUrls;
}

export const siteUrlsSelector: Selector<AppState, SpacesSiteUrls> = createSelector(
  selectSessionSite,
  queryStringSelector,
  // Some code, including populateContentBreadcrumbs, expect SpacesSiteUrls to be falsy
  // when there's no session (and hence no session site).  This preserves that behavior.
  (site, queryString) => site ? new SpacesSiteUrls({ siteUrlName: site.urlName, queryString }) : null
);

export const mapStateToSiteUrlsProps: MapStateToProps<SiteUrlsProps> =
  (state: AppState): SiteUrlsProps => ({
    urls: siteUrlsSelector(state)
  });
